import { useState } from 'react';

export default function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-indigo-50 text-gray-800 font-sans">
      {/* Header */}
      <header className="p-6 flex justify-between items-center border-b border-indigo-100 bg-white shadow-sm relative z-10">
        <a href="/" className="text-2xl font-bold tracking-tight text-indigo-700">veritiva.ai</a>

        <button
          className="md:hidden text-indigo-700 focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        <nav className={`md:flex space-x-6 text-sm absolute md:static bg-white md:bg-transparent top-16 left-0 w-full md:w-auto md:space-x-6 ${menuOpen ? 'block' : 'hidden'} md:block px-6 py-4 md:p-0 shadow-md md:shadow-none`}>
          <a href="#features" className="block py-2 md:py-0 hover:text-indigo-700">Features</a>
          <a href="#about" className="block py-2 md:py-0 hover:text-indigo-700">About</a>
          <a href="#contact" className="block py-2 md:py-0 hover:text-indigo-700">Contact</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="px-6 md:px-10 py-20 md:py-24 text-center bg-gradient-to-r from-white via-sky-100 to-indigo-50">
        <h2 className="text-3xl md:text-5xl font-extrabold leading-tight text-indigo-900 max-w-4xl mx-auto">
          Fast. Accurate. Effortless Compliance.
        </h2>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-indigo-700 max-w-xl mx-auto">
          veritiva.ai evaluates your policies against complex regulations in seconds. Upload your documents, and we handle the rest.
        </p>
        <div className="mt-6 md:mt-8">
          <a href="/upload" className="inline-block bg-indigo-600 text-white px-6 py-3 rounded shadow hover:bg-indigo-700">Start for Free</a>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-indigo-800 mb-10">Built for Regulatory Speed and Accuracy</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 text-center">
            <div>
              <h4 className="text-lg md:text-xl font-semibold text-indigo-700 mb-2">Lightning-Fast Evaluation</h4>
              <p className="text-gray-600">Process large documents in seconds using AI-powered parsing.</p>
            </div>
            <div>
              <h4 className="text-lg md:text-xl font-semibold text-indigo-700 mb-2">High Accuracy Mapping</h4>
              <p className="text-gray-600">Match policies against state and federal regulations reliably.</p>
            </div>
            <div>
              <h4 className="text-lg md:text-xl font-semibold text-indigo-700 mb-2">Exportable Reports</h4>
              <p className="text-gray-600">Generate summaries for audits and internal reviews in one click.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 md:py-20 bg-sky-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-indigo-800 mb-4">Who We Are</h3>
          <p className="text-indigo-700 text-base md:text-lg">
            veritiva.ai is a compliance automation platform built for labs, hospitals, and healthcare providers who want to save time and stay ahead of evolving regulations.
          </p>
        </div>
      </section>

      {/* Pricing Inquiry Section */}
      <section id="pricing" className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-indigo-800 mb-4">Custom Pricing for Every Team</h3>
          <p className="text-gray-600 mb-6 text-base md:text-lg">
            Whether you're a small team or a large institution, we tailor our plans to meet your needs.
          </p>
          <a href="#contact" className="inline-block bg-indigo-600 text-white px-6 py-3 rounded hover:bg-indigo-700">Contact Sales</a>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 md:py-20 bg-indigo-50">
        <div className="max-w-xl mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-indigo-800 mb-4">Get in Touch</h3>
          <p className="text-indigo-700 mb-4 text-base md:text-lg">Have questions or need a custom demo?</p>
          <a href="mailto:support@veritiva.ai" className="text-indigo-600 underline">support@veritiva.ai</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="p-6 text-center text-sm text-gray-500 border-t border-gray-200">
        &copy; {new Date().getFullYear()} veritiva.ai. All rights reserved.
      </footer>
    </div>
  );
}
